enum TraceLevel {
    Info,
    Warning,
    Error
}

export default TraceLevel;